import { Injectable, inject } from "@angular/core";
import { Observable, from } from "rxjs";
import { filter, map, take } from "rxjs/operators";
import { ExperimentService } from "src/app/shared/services/experiment.service";
import { EXPERIMENT_KEYS } from "src/app/experiments/experiment-keys.index";

@Injectable({ providedIn: "root" })
export class RestoreLandingGa4EventsExperimentKeyService {
  private readonly experimentService = inject(ExperimentService);

  private static readonly KEY =
    "YABETSE-Restore-Landing-GA4-Events-CORE-170" as const;

  value$() {
    return this.experimentService.value$(
      RestoreLandingGa4EventsExperimentKeyService.KEY,
      EXPERIMENT_KEYS["YABETSE-Restore-Landing-GA4-Events-CORE-170"]
    );
  }

  get() {
    return this.experimentService.get(
      RestoreLandingGa4EventsExperimentKeyService.KEY,
      EXPERIMENT_KEYS["YABETSE-Restore-Landing-GA4-Events-CORE-170"]
    );
  }

  isOn(defaultVal = false) {
    return this.experimentService.isOn(
      RestoreLandingGa4EventsExperimentKeyService.KEY,
      defaultVal
    );
  }

  whenReady$(): Observable<boolean> {
    return from(this.experimentService.whenReady()).pipe(
      take(1),
      map(() => this.isOn(false))
    );
  }

  whenOn(fn: () => void) {
    return this.value$()
      .pipe(
        filter((v) => v),
        take(1)
      )
      .subscribe((v) => v && fn());
  }
}
